import React from 'react';
import { Form, Button } from 'react-bootstrap';
import SearchArticleComponent from "../../../components/troubleShooting/search/SearchArticleComponent";
//import LoaderComponent from '../../layout/loaderComponent';
const ArticleListComponent = (props) => {
    let pageData = props.pageData;
    return (
        <div className="">
            {pageData ?

                <div className="articleSearchResult">

                    <h3 className="text-left page-title">
                        {
                            props.category_search ?
                            pageData.searchPageTitle1 + " > " + props.category_search
                            :  !props.category_search && props.searchOption.search_key === "free-text" ?
                            pageData.searchPageTitle1 : pageData.searchPageTitle1
                              /*   props.searchOption && props.searchOption.search_key === "free-text" ?
                                pageData.searchPageTitle1 : props.searchOption.search_key === "category" ?
                                pageData.searchPageTitle1 + " > " + props.searchOption.search_value : pageData.pageTitle  : props.searchOption && props.searchOption.search_key === "free-text" ?
                                pageData.searchPageTitle1 : props.searchOption.category_search ?
                                pageData.searchPageTitle1 + " > " + props.searchOption.category_search : pageData.searchPageTitle1  */
                        }
                    </h3>
                    <h6 className="text-left">
                        {  /* props.articleList && props.articleList.statusCode ===200 && props.articleList.total ? ` Total Records : `+props.articleList.total : '' */}
                    </h6>

                    <SearchArticleComponent pageData={pageData} searchOption={props.searchOption} disableSearchBtn={true} changeEvent={props.changeEvent} submitEvent={props.submitEvent} catSearch={props.catSearch} focusEvent={props.focusEvent} blurEvent={props.blurEvent} searchPlaceHolder={props.searchPlaceHolder} />



                    {props.articleList && props.articleList.articles && props.articleList.statusCode === 200 && props.articleList.total > 0 ?
                        <ul className="list-group list-group-flush text-left" id="SearchResultDiv">
                            {props.articleList.articles.map((article, index) =>
                                <li key={index} className="list-group-item Hiragino" data-articleid={article.id} data-title={article.title} onClick={props.listClickEvent.bind(this, article.id, article.title)}>
                                    <span className="QuesTitle"> Q.{article.title} </span><span className="pull-right">{/* <i className="fa fa-angle-right"></i> */} <img src="/images/icon_right_gray.png" className="icon_right_gray" alt="right arrow" /></span>
                                </li>
                            )}
                        </ul>
                        :

                        <div className="mt-5 text-center">
                            <p>{pageData.NoArticleListMsg1}</p>
                            <p> {pageData.NoArticleListMsg2}</p>
                        </div>

                    }

                    {props.articleList && props.articleList.statusCode === 200 && props.articleList.total > 0 ?
                        <>
                            <Form.Group controlId="viewMoreBtn">
                                <Button disabled={props.articleList && props.articleList.articles.length === props.articleList.total ? true : false} onClick={props.viewMoreResultAction} className="bg-gray col-sm-4 bg-danger loadMoreBtn " size="md" type="button" variant="outline-secondary">{pageData.viewMoreResult}</Button>
                            </Form.Group>
                        </> : ''}
                </div> : ""
            }
        </div>
    );
};

export default ArticleListComponent;